import script from "./ResetPassword.vue?vue&type=script&setup=true&name=Reset&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&name=Reset&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=208c4381&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208c4381"]])

export default __exports__